'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _analyticsBot = require('./analytics-bot.component');

var _analyticsBot2 = _interopRequireDefault(_analyticsBot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsModule = _angular2.default.module('app.containers.analytics-bot', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('analyticsBot', {
    url: '/analytics-bot',
    template: '<analytics-bot></analytics-bot>'
  });
}).component('analyticsBot', _analyticsBot2.default);

exports.default = analyticsModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics-bot/analytics-bot.js
 **/